/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line

  class SlidingNavAnimation {
    constructor(nav, focusEl) {
      this.nav = nav;
      this.links = Array.from(this.nav.querySelectorAll('.menu__item'));
      this.focus = focusEl;
      if (!this.links.length || !this.focus) return;
      this._init();
    }

    _init() {
      this._startPosition(this.focus, this.links[0]);

      const onMouseOut = () => {
        this.focus.style.opacity = '0';
      };

      this.links.forEach(link => {
        link.addEventListener('mouseover', () => {
          this._changePosition(this.focus, link);
        });
      });

      this.nav.addEventListener('mouseout', onMouseOut);
    }

    _setFocusElementPosition(focusEl, target) {
      focusEl.style.width = `${target.offsetWidth}px`;
      focusEl.style.height = `${target.offsetHeight}px`;
      focusEl.style.top = `${target.offsetTop + target.offsetHeight / 2}px`;
      focusEl.style.left = `${target.offsetLeft + target.offsetWidth / 2}px`;
      focusEl.style.transform = 'translate(-50%, -50%)';
    }

    _startPosition(focusEl, target) {
      this._setFocusElementPosition(focusEl, target);
    }

    _changePosition(focusEl, target) {
      this._setFocusElementPosition(focusEl, target);
      focusEl.style.opacity = '1';
    }
  }

  class InstaMarqueeHandler {
        constructor(e) {
            this.fetchUrl = e, this.container = document.getElementById("ig-feed"), this.fetchUrl ? this._init() : console.error("Behold.io URL is not valid")
        }
        async _init() {
            const e = await this._fetchData(this.fetchUrl);
            e && e.posts && (this._addSlides(e.posts), this._addIconClasses(), this._cloneSlides())
        }
        async _fetchData(e) {
            try {
                const t = await fetch(e);
                return await t.json()
            } catch (e) {
                console.error(e)
            }
        }
        _addSlides(e) {
            e.forEach(((e, t) => {
                this._createSlides(e)
            }))
        }
        _videoContent(e, t) {
            return `<a href="${e}" target="_blank" aria-label="View Instagram Post">\n <div class="ig-image-overlay"></div>\n <video autoplay muted loop playsinline name="media" alt="Unwell Instagram Video">\n <source src="${t}" type="video/mp4">\n </video>\n </a>`
        }
        _imageContent(e, t) {
            return `<a href="${e}" target="_blank" aria-label="View Instagram Post">\n <div class="ig-image-overlay"></div>\n <img src="${t}" width="800" height="auto" alt="Unwell Instagram Post"/> \n </a>`
        }
        async _createSlides(e) {
            const t = document.createElement("div");
            t.classList.add("ig-marquee-slide");
            const i = e.mediaType.toLowerCase();
            if ("video" === i) t.innerHTML = this._videoContent(e.permalink, e.mediaUrl);
            else if ("image" === i) t.innerHTML = this._imageContent(e.permalink, e.mediaUrl);
            else if ("carousel_album" === i) {
                const i = e.children[0],
                    o = i.mediaType.toLowerCase();
                "video" === o ? t.innerHTML = this._videoContent(e.permalink, i.mediaUrl) : "image" === o && (t.innerHTML = this._imageContent(e.permalink, i.mediaUrl))
            } else console.error(`Media type of "${i}" cannot be displayed in the Instagram feed.`);
            const o = document.createElement("div");
            o.classList.add("ig-marquee-slide-wrapper"), this._setAspectRatio(o), o.appendChild(t), this.container.appendChild(o)
        }
        _setAspectRatio(e) {
            const t = 1 + .125 * Math.floor(4 * Math.random());
            e.style.aspectRatio = `1/${t}`
        }
        async _addIconClasses() {
            const e = [...this.container.querySelectorAll(".ig-marquee-slide-wrapper")],
                t = Math.floor(e.length / 2),
                i = [e[0], e[t]];
            e.length > 11 ? e.forEach(((e, t) => {
                t % 4 == 0 && e.classList.add("icon-added")
            })) : e.length > 4 ? i.forEach((e => {
                e.classList.add("icon-added")
            })) : e[0].classList.add("icon-added")
        }
        _cloneSlides() {
            const e = this.container.innerHTML;
            this.container.innerHTML += e
        }
    }

  class MobileNavScrollAnimation {
  constructor() {
    this.homeVideoHero = document.querySelector("#unwell-hydration .video-hero");
    this.mobileNav = document.querySelector("#unwell-hydration .header__mobile");
    if (this.homeVideoHero && this.mobileNav) this._init();
  }

  _init() {
    if (typeof gsap === 'undefined' || !gsap.matchMedia) return;

    gsap.matchMedia().add("(max-width: 499px)", () => {
      gsap.timeline({
        scrollTrigger: {
          trigger: this.homeVideoHero,
          start: "bottom 85%",
          end: "bottom 10%",
          scrub: 1.05
        }
      }).to(this.mobileNav, {
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(10px)"
      });
    });
  }
}



  class FAQFilteringHandler {
    constructor() {
      this.faqSections = [...document.querySelectorAll('[data-faq-heading]')];
      this.accordions = [...document.querySelectorAll('[data-faq-accordion]')];

      if (!this.faqSections.length) return;
      this._init();
    }

    _init() {
      this._setInitialState();
      this.faqSections.forEach(section => {
        const id = section.getAttribute('data-faq-heading');
        section.addEventListener('click', () => {
          this._hideAccordions();
          this._showAccordions(id);
        });
      });
    }

    _setInitialState() {
      const firstKey = this.faqSections[0].getAttribute('data-faq-heading');
      this._showAccordions(firstKey);
    }

    _showAccordions(key) {
      [...document.querySelectorAll(`[data-faq-accordion="${key}"]`)].forEach(acc => {
        acc.classList.remove('hidden-accordion');
        acc.classList.add('visible-accordion');
      });
    }

    _hideAccordions() {
      this.accordions.forEach(acc => {
        acc.classList.remove('visible-accordion');
        acc.classList.add('hidden-accordion');
      });
    }
  }

  const changeLogoOverFooter = {
    _init() {
      const header = document.querySelector('header.theme__header');
      const footer = document.querySelector('footer.footer-sections');

      if (!header || !footer || !(window.gsap && window.ScrollTrigger)) return;

      const body = document.body;

      ScrollTrigger.create({
        trigger: footer,
        start: 'top 25%',
        end: 'bottom bottom',
        onEnter: () => body.classList.add('header-over-footer'),
        onLeaveBack: () => body.classList.remove('header-over-footer')
      });
    }
  };

  const externalLinksHandler = {
    _init() {
      const hostname = window.location.hostname;
      const links = document.querySelectorAll('a[href^="http"]');

      links.forEach(link => {
        if (link.hostname && link.hostname !== hostname) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
      });
    }
  };

  const playVideos = {
    _init() {
      const videos = document.querySelectorAll('video[autoplay]');
      if (!videos.length) return;

      const loadAll = () => {
        videos.forEach(video => {
          try {
            video.load();
          } catch (e) {
            console.warn('Video load failed', e);
          }
        });
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadAll);
      } else {
        setTimeout(loadAll, 300);
      }
    }
  };

  /* ============================================
     Image Tabs Controller (desktop + mobile sync)
     ============================================ */
  function initImageTabs(root) {
    if (!root) return;

    // Desktop hooks
    const dTablist = root.querySelector('.image-tabs__desktop .image-tabs__tabs');
    const dTabs = dTablist ? Array.from(dTablist.querySelectorAll('.image-tabs__tab')) : [];
    const dPanels = Array.from(root.querySelectorAll('.image-tabs__panel'));
    const dImages = Array.from(root.querySelectorAll('.image-tabs__media-inner [data-image]'));
    const dBadges = Array.from(root.querySelectorAll('.image-tabs__badges [data-badge]'));

    function activateDesktop(id) {
      dTabs.forEach(btn => {
        const active = btn.dataset.target === id;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      dPanels.forEach(panel => {
        panel.classList.toggle('is-active', panel.id === 'panel-' + id);
      });

      dImages.forEach(imgWrap => {
        imgWrap.classList.toggle('is-active', imgWrap.dataset.image === id);
      });

      dBadges.forEach(badge => {
        badge.classList.toggle('is-active', badge.dataset.badge === id);
      });
    }

    // Mobile hooks
    const track = root.querySelector('.image-tabs__track--mobile');
    const slides = Array.from(root.querySelectorAll('.image-tabs__slide'));
    const mTabGroups = Array.from(root.querySelectorAll('.image-tabs__tabs--mobile'));

    const idOrder = slides.map(s => s.dataset.id);
    function indexFor(id) {
      return idOrder.indexOf(id);
    }

    function setTrackTo(id) {
      const idx = indexFor(id);
      if (idx < 0) return;
      if (track) track.style.setProperty('--index', idx);
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    }

    function updateAllMobileTabbars(id) {
      mTabGroups.forEach(group => {
        const tabs = Array.from(group.querySelectorAll('.image-tabs__tab'));
        tabs.forEach(btn => {
          const active = btn.dataset.target === id;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    }

    function activateEverywhere(id) {
      setTrackTo(id);
      updateAllMobileTabbars(id);
      activateDesktop(id);
    }

    // Initial selection
    const initialId = idOrder[0] || (dTabs[0] && dTabs[0].dataset.target);
    if (initialId) activateEverywhere(initialId);

    // Events: mobile tabs
    root.addEventListener('click', e => {
      const btn = e.target.closest('.image-tabs__tabs--mobile .image-tabs__tab');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.target;
      activateEverywhere(id);
    });

    // Keyboard support for mobile tabs
    root.addEventListener('keydown', e => {
      const btn = e.target.closest('.image-tabs__tabs--mobile .image-tabs__tab');
      if (!btn) return;

      const group = btn.closest('.image-tabs__tabs--mobile');
      const tabs = Array.from(group.querySelectorAll('.image-tabs__tab'));
      const i = tabs.indexOf(btn);

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        tabs[(i + 1) % tabs.length].focus();
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        tabs[(i - 1 + tabs.length) % tabs.length].focus();
      }
      if (e.key === 'Home') {
        e.preventDefault();
        tabs[0].focus();
      }
      if (e.key === 'End') {
        e.preventDefault();
        tabs[tabs.length - 1].focus();
      }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateEverywhere(btn.dataset.target);
      }
    });

    // Desktop <-> mobile sync
    dTabs.forEach(btn => {
      btn.addEventListener('click', () => activateEverywhere(btn.dataset.target));
    });
  }

  /* ============================================
     Columns Bottle Animation
     ============================================ */
  function initColumnsBottle() {
    if (!(window.gsap && window.ScrollTrigger)) return;

    const roots = document.querySelectorAll('[id^="ColumnsBottle--"]');
    roots.forEach(root => {
      const bottleImg = root.querySelector('[data-bottle-anim] img');
      if (!bottleImg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      gsap.set(bottleImg, { transformOrigin: '50% 85%' });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.2
        }
      });

      tl.fromTo(
        bottleImg,
        { yPercent: 0, rotate: 0, scale: 1 },
        { yPercent: -8, rotate: -4, scale: 1.05, ease: 'none' }
      );
    });
  }

  /* ============================================
     Custom Product Accordion for Quantity Variants
     ============================================ */
  (function() {
    const acc = document.querySelector('.shop-accordion[data-accordion]');
    if (!acc) return;

    const has12 = acc.getAttribute('data-has-12') === 'true';
    const $default = acc.querySelector('.links-default');
    const $twelve = acc.querySelector('.links-12');

    function isTwelveSelected() {
      const radios = Array.from(
        document.querySelectorAll('[data-single-option-selector][type="radio"]:checked')
      );
      const selects = Array.from(
        document.querySelectorAll('[data-single-option-selector]:not([type="radio"])')
      );
      const values = [
        ...radios.map(r => ((r && r.value) || '').toLowerCase()),
        ...selects.map(s => ((s && s.value) || '').toLowerCase())
      ];

      const vt = document.querySelector('[data-product-variant-title]');
      if (vt) values.push(vt.textContent.toLowerCase());

      return values.some(v =>
        v.includes('12-pack') ||
        v.includes('12 pack') ||
        v.includes('12pk') ||
        v === '12'
      );
    }

    function update() {
      if (!has12 || !$default) return;
      const twelve = isTwelveSelected();

      if ($twelve) {
        $twelve.style.display = twelve ? '' : 'none';
        $default.style.display = twelve ? 'none' : '';
      } else {
        $default.style.display = '';
      }
    }

    // Initial state
    update();

    // Listen to option changes
    document.addEventListener('change', e => {
      if (e.target.matches('[data-single-option-selector], .select-popout__option')) update();
    });

    document.addEventListener('click', e => {
      if (e.target.closest('.select-popout__option')) {
        setTimeout(update, 0);
      }
    });
  })();

  function initializeScripts() {
    // Everything in here is "heavier"; we run it lazily
    if (!(window.gsap && window.ScrollTrigger)) return;

    gsap.registerPlugin(ScrollTrigger);

    // Homepage hero animation
    if (typeof HomepageHeroAnimation !== 'undefined') {
      new HomepageHeroAnimation();
    }

    // Sliding nav (desktop only)
    const headerMenu = document.querySelector('.header__menu');
    const hoverBg = headerMenu && headerMenu.querySelector('.header_hover__bg');
    if (headerMenu && hoverBg && window.matchMedia('(min-width: 1000px)').matches) {
      headerMenu.classList.add('slider-nav');
      new SlidingNavAnimation(headerMenu, hoverBg);
    }

    // Badge / text float animations
    if (typeof BadgeFloatAnimation !== 'undefined') {
      [...document.querySelectorAll('.badge-float__container')].forEach(container => {
        new BadgeFloatAnimation(container);
      });
    }

    if (typeof TextFloatAnimation !== 'undefined') {
      [...document.querySelectorAll('.text-float__container')].forEach(container => {
        new TextFloatAnimation(container);
      });
    }

    //mobile header 
    new MobileNavScrollAnimation();
     // Insta
    new InstaMarqueeHandler(beholdURL);

    // FAQ filtering
    new FAQFilteringHandler();

    // Header logo change over footer (ScrollTrigger)
    changeLogoOverFooter._init();

    // External link handling and autoplay video loading
    externalLinksHandler._init();
    playVideos._init();


    // Image tab components
    const imageTabsRoots = document.querySelectorAll('[id^="ImageTabs--"]');
    if (imageTabsRoots.length) {
      imageTabsRoots.forEach(root => initImageTabs(root));
    }

    // Bottle animation
    initColumnsBottle();
  }

  function initializeSwipers() {
  if (typeof Swiper === 'undefined') return;

  // --- PRODUCT GALLERY (custom gallery / thumbs first) ---
  const productGalleryEl = document.querySelector('.swiper-product-gallery');
  if (productGalleryEl) {
    // Create Swiper instance on this specific element
    const productGallerySwiper = new Swiper(productGalleryEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
        snapOnRelease: true
      }
    });

    const thumbs = productGalleryEl.querySelectorAll('.product-gallery__thumb');

    // Click thumb → go to that slide + update active state
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();

        const index = parseInt(thumb.dataset.thumbIndex, 10);
        if (!isNaN(index)) {
          productGallerySwiper.slideTo(index); // 0-based index
        }

        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // Swiping the main gallery → sync active thumb
    productGallerySwiper.on('slideChange', () => {
      const activeIndex = productGallerySwiper.activeIndex;

      thumbs.forEach((thumb) => {
        const idx = parseInt(thumb.dataset.thumbIndex, 10);
        thumb.classList.toggle('is-active', idx === activeIndex);
      });
    });
  }

  // --- OTHER CUSTOM SWIPER (unchanged) ---
  const customGalleryEl = document.querySelector('.swiper-custom-gallery');
  if (customGalleryEl) {
    new Swiper('.swiper-custom-gallery', {
      slidesPerView: 2,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  }
}

  // GSAP: Homepage video energy expand-on-scroll
  function initHeroVideoExpand() {
    if (!(window.gsap && window.ScrollTrigger)) return;

    const heroes = gsap.utils.toArray(
      '.index-hero.hero-expand-on-scroll .hero__video'
    );

    if (!heroes.length) return;

    gsap.registerPlugin(ScrollTrigger);

    heroes.forEach(hero => {
      const container = hero.closest('.index-hero.hero-expand-on-scroll');
      if (!container) return;

      gsap.set(hero, {
        scale: 0.4
      });

      gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: 'top top',
          end: '+=150%',
          scrub: true,
          pin: true,
          anticipatePin: 1
        }
      }).to(
        hero,
        {
          scale: 1.1,
          borderRadius: '0rem',
          ease: 'none'
        },
        0
      );
    });
  }

 document.addEventListener('DOMContentLoaded', () => {
  externalLinksHandler._init();
  initHeroVideoExpand(); 

  const runHeavy = () => {
    initializeScripts();
    initializeSwipers();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runHeavy);
  } else {
    setTimeout(runHeavy, 400);
  }
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-accordion-toggle]');
  if (!btn) return;

  const expanded = btn.getAttribute('aria-expanded') === 'true';
  const panelId = btn.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;
  if (!panel) return;

  // OPTIONAL: close other open panels inside the same menu level
  const wrapper = btn.closest('.sliderule__wrapper')?.parentElement;
  if (wrapper) {
    wrapper.querySelectorAll('[data-accordion-toggle][aria-expanded="true"]').forEach((otherBtn) => {
      if (otherBtn === btn) return;
      const otherPanel = document.getElementById(otherBtn.getAttribute('aria-controls'));
      otherBtn.setAttribute('aria-expanded', 'false');
      if (otherPanel) otherPanel.hidden = true;
    });
  }

  btn.setAttribute('aria-expanded', String(!expanded));
  panel.hidden = expanded;
});



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
